export const WEBSITE_ASTRO_T10_ITEMS = [
  {
    "time": "2026-10-01 15:00",
    "name": "Case Study Tour Doanh Nghiệp: Lado Spice Phan Thiết – Thích Cay",
    "cat": "Case Study (Doanh nghiệp & B2B)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/hanh-trinh-phan-thiet-cua-lado-spice",
    "desc": "Chuẩn hóa Case Study B2B với tỷ lệ ảnh 16:9, bảng thông tin nhanh 4 cột, tối ưu SEO Schema Article và bộ nhận diện thương hiệu Lado Spice.",
    "rel": "hanh-trinh-phan-thiet-cua-lado-spice.astro",
    "stt": 1
  },
  {
    "time": "2026-10-02 11:36",
    "name": "Điều Khoản Dịch Vụ & Chính Sách Hoàn Hủy Tour FIT TOUR",
    "cat": "Page (Doanh nghiệp & Dịch vụ)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/dieu-khoan-dich-vu",
    "desc": "Cập nhật điều khoản đặt cọc, thanh toán và hoàn hủy chi tiết cho tour Nhật Bản, Hokkaido và Châu Âu; chuẩn hóa số giấy phép lữ hành quốc tế mới.",
    "rel": "dieu-khoan-dich-vu.astro",
    "stt": 2
  },
  {
    "time": "2026-10-02 11:36",
    "name": "Tour Hokkaido 6N6Đ trọn gói - Bay All Nippon Airway 5 sao",
    "cat": "Tour (Sản phẩm)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-hokkaido-6n6d",
    "desc": "add specific booking, cancellation, and visa terms for Japan & Hokkaido tours",
    "rel": "tour/tour-hokkaido-6n6d.astro",
    "stt": 3
  },
  {
    "time": "2026-10-02 11:36",
    "name": "Tour du lịch Hokkaido 6N5Đ mùa đông Nhật Bản - Buffet Cua Nanda",
    "cat": "Tour (Sản phẩm)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-hokkaido",
    "desc": "add specific booking, cancellation, and visa terms for Japan & Hokkaido tours",
    "rel": "tour/tour-hokkaido.astro",
    "stt": 4
  },
  {
    "time": "2026-10-02 11:36",
    "name": "Tour Nhật Bản 6 ngày 5 đêm Trọn gói - Cung đường bạch kim",
    "cat": "Tour (Sản phẩm)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-nhat-ban-6n5d",
    "desc": "add specific booking, cancellation, and visa terms for Japan & Hokkaido tours",
    "rel": "tour/tour-nhat-ban-6n5d.astro",
    "stt": 5
  },
  {
    "time": "2026-10-02 19:10",
    "name": "Case Study Tour Y Tế MICE: Bệnh Viện Mắt Sài Gòn Tham Dự ESCRS London",
    "cat": "Case Study (Doanh nghiệp & B2B)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/benh-vien-mat-sai-gon-tai-escrs",
    "desc": "Thiết kế trang Editorial tạp chí quốc tế, bảo mật dữ liệu đoàn 15 bác sĩ, tích hợp ảnh thực địa tại Trung tâm Hội nghị ExCeL London và Sân vận động Emirates.",
    "rel": "benh-vien-mat-sai-gon-tai-escrs.astro",
    "stt": 6
  },
  {
    "time": "2026-10-02 20:50",
    "name": "Case Study Doanh Nghiệp: Thiết Bị Y Tế Việt Can Tại ESCRS London & UK Tour",
    "cat": "Case Study (Doanh nghiệp & B2B)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/viet-can-tai-escrs-2026-london",
    "desc": "Xây dựng trang Case Study B2B cao cấp với luồng sự kiện 7 ngày, tối ưu mobile executive dock, liên kết chéo hệ sinh thái MICE Châu Âu và báo VTC News.",
    "rel": "viet-can-tai-escrs-2026-london.astro",
    "stt": 7
  },
  {
    "time": "2026-10-03 15:41",
    "name": "Kinh Nghiem Du Lich Sri Lanka",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/kinh-nghiem-du-lich-sri-lanka",
    "desc": "hoàn thiện mạng lưới internal link silo 32 bài viết Sri Lanka, sửa link gãy và chuẩn hóa deduplication",
    "rel": "kinh-nghiem-du-lich-sri-lanka.astro",
    "stt": 8
  },
  {
    "time": "2026-10-04 09:25",
    "name": "Tại Sao Tàu Hỏa Sri Lanka Nổi Tiếng Thế Giới? Lịch Sử Tuyến Đường Sắt Đồi Chè Thế Kỷ 19",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tai-sao-tau-hoa-sri-lanka-noi-tieng",
    "desc": "lock authoritative de-cannibalized title for tai-sao-tau-hoa-sri-lanka-noi-tieng",
    "rel": "tai-sao-tau-hoa-sri-lanka-noi-tieng.astro",
    "stt": 9
  },
  {
    "time": "2026-10-04 09:25",
    "name": "Tour Sri Lanka 8N7Đ (Bản nháp Test)",
    "cat": "Tour (Sản phẩm)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-sri-lanka",
    "desc": "docs & feat: cập nhật GLOSSARY, ADR 0004 phân tách intent 2 bài tàu hỏa và chuẩn hóa thời lượng tour 8N8Đ",
    "rel": "tour/tour-sri-lanka.astro",
    "stt": 10
  },
  {
    "time": "2026-10-04 09:25",
    "name": "Cầu 9 Nhịp Ở Sri Lanka - Nine Arch Bridge Ella",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/cau-9-nhip",
    "desc": "hoàn thiện mạng lưới internal link silo 32 bài viết Sri Lanka, sửa link gãy và chuẩn hóa deduplication",
    "rel": "cau-9-nhip.astro",
    "stt": 11
  },
  {
    "time": "2026-10-04 09:25",
    "name": "Chùa Hang Dambulla - 5 Hang Đá, 157 Pho Tượng Và Di Sản UNESCO Sri Lanka",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/chua-hang-dambulla",
    "desc": "hoàn thiện mạng lưới internal link silo 32 bài viết Sri Lanka, sửa link gãy và chuẩn hóa deduplication",
    "rel": "chua-hang-dambulla.astro",
    "stt": 12
  },
  {
    "time": "2026-10-04 09:25",
    "name": "Kandyan Dance Sri Lanka - Điệu Nhảy Truyền Thống Của Kandy",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/dieu-nhay-kandyan-dance",
    "desc": "hoàn thiện mạng lưới internal link silo 32 bài viết Sri Lanka, sửa link gãy và chuẩn hóa deduplication",
    "rel": "dieu-nhay-kandyan-dance.astro",
    "stt": 13
  },
  {
    "time": "2026-10-04 09:25",
    "name": "Pháo Đài Sigiriya: Thành Phố Cung Điện Trên Đá Và Di Sản UNESCO Sri Lanka",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/phao-dai-sigiriya",
    "desc": "hoàn thiện mạng lưới internal link silo 32 bài viết Sri Lanka, sửa link gãy và chuẩn hóa deduplication",
    "rel": "phao-dai-sigiriya.astro",
    "stt": 14
  },
  {
    "time": "2026-10-04 09:25",
    "name": "Anuradhapura: Thành Cổ Thiêng Liêng Và Cái Nôi Phật Giáo Sri Lanka",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/thanh-co-anuradhapura",
    "desc": "hoàn thiện mạng lưới internal link silo 32 bài viết Sri Lanka, sửa link gãy và chuẩn hóa deduplication",
    "rel": "thanh-co-anuradhapura.astro",
    "stt": 15
  },
  {
    "time": "2026-10-04 09:25",
    "name": "Nuwara Eliya - Thị Trấn Trà Và Little England Của Sri Lanka",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/thi-tran-nuwara-eliya",
    "desc": "hoàn thiện mạng lưới internal link silo 32 bài viết Sri Lanka, sửa link gãy và chuẩn hóa deduplication",
    "rel": "thi-tran-nuwara-eliya.astro",
    "stt": 16
  },
  {
    "time": "2026-10-04 09:25",
    "name": "4 Tượng Phật Gal Vihara - Di Sản Phật Giáo Nổi Tiếng Sri Lanka",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tuong-phat-gal-vihara",
    "desc": "hoàn thiện mạng lưới internal link silo 32 bài viết Sri Lanka, sửa link gãy và chuẩn hóa deduplication",
    "rel": "tuong-phat-gal-vihara.astro",
    "stt": 17
  },
  {
    "time": "2026-10-04 09:25",
    "name": "Vì Sao Sri Lanka Có Hai Mùa Gió Mùa? Giải Thích Yala, Maha Và Quy Luật Tự Nhiên Định Hình Du Lịch",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/vi-sao-sri-lanka-co-2-mua-gio",
    "desc": "Optimize photos and hotline for vi-sao-sri-lanka-co-2-mua-gio",
    "rel": "vi-sao-sri-lanka-co-2-mua-gio.astro",
    "stt": 18
  },
  {
    "time": "2026-10-04 09:25",
    "name": "Du Lịch Sri Lanka Mùa Nào Đẹp? Thời Điểm Lý Tưởng Theo Từng Tháng Và Khu Vực",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/du-lich-sri-lanka-mua-nao-dep",
    "desc": "Optimize photos and content layout for du-lich-sri-lanka-mua-nao-dep",
    "rel": "du-lich-sri-lanka-mua-nao-dep.astro",
    "stt": 19
  },
  {
    "time": "2026-10-04 09:25",
    "name": "Du Lịch Sri Lanka Có An Toàn Không? Những Rủi Ro Thực Tế Và Cách Phòng Tránh",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/du-lich-sri-lanka-co-an-toan",
    "desc": "cap nhat bo anh thuc te doc ban tu gallery va cai thien bo cuc bai du-lich-sri-lanka-co-an-toan",
    "rel": "du-lich-sri-lanka-co-an-toan.astro",
    "stt": 20
  },
  {
    "time": "2026-10-04 09:25",
    "name": "Chi Phí Du Lịch Sri Lanka - Đi Sri Lanka Hết Bao Nhiêu Tiền?",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/chi-phi-du-lich-sri-lanka",
    "desc": "cap nhat 100% anh thuc te FIT TOUR va hinh anh Huynh Hieu cho bai chi phi du lich sri lanka",
    "rel": "chi-phi-du-lich-sri-lanka.astro",
    "stt": 21
  },
  {
    "time": "2026-10-04 09:25",
    "name": "Sri Lanka Có Cần Visa Không? Hướng Dẫn ETA Cho Người Việt 2026",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/sri-lanka-co-can-visa-khong",
    "desc": "cap nhat 100% anh thuc te FIT TOUR va hinh anh Huynh Hieu cho bai viet visa sri lanka",
    "rel": "sri-lanka-co-can-visa-khong.astro",
    "stt": 22
  },
  {
    "time": "2026-10-04 09:25",
    "name": "Du Lịch Sri Lanka Tự Túc - Kinh Nghiệm Lên Route Và Đi Lại",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/du-lich-sri-lanka-tu-tuc",
    "desc": "cap nhat 100% anh thuc te FIT TOUR va hinh anh Huynh Hieu, loai bo anh cu",
    "rel": "du-lich-sri-lanka-tu-tuc.astro",
    "stt": 23
  },
  {
    "time": "2026-10-04 09:25",
    "name": "Sri Lanka Có Gì Đặc Biệt? 20 Điều Khiến Đảo Quốc Này Khác Biệt",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/sri-lanka-co-gi-dac-biet",
    "desc": "cap nhat 100% anh thuc dia tu chuyen di cho bai viet sri lanka co gi dac biet",
    "rel": "sri-lanka-co-gi-dac-biet.astro",
    "stt": 24
  },
  {
    "time": "2026-10-04 09:25",
    "name": "Chuẩn Bị Gì Khi Du Lịch Sri Lanka - Checklist Thực Tế Cho Khách Việt",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/chuan-bi-gi-khi-du-lich-sri-lanka",
    "desc": "toi uu ty le anh vuong 1:1 va giao dien checklist icon",
    "rel": "chuan-bi-gi-khi-du-lich-sri-lanka.astro",
    "stt": 25
  },
  {
    "time": "2026-10-04 09:25",
    "name": "Top 14 Địa Điểm Du Lịch Sri Lanka: Di Sản, Đồi Trà, Safari Và Biển",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/dia-diem-du-lich-sri-lanka",
    "desc": "toi uu Top 14 dia diem du lich Sri Lanka theo Phuong an A, bo sung anh that va internal link silo",
    "rel": "dia-diem-du-lich-sri-lanka.astro",
    "stt": 26
  },
  {
    "time": "2026-10-04 09:25",
    "name": "Đặc Sản Sri Lanka - Ăn Gì Ở Sri Lanka? 28 Món Nên Thử",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/an-gi-sri-lanka",
    "desc": "Cập nhật 13 ảnh minh họa thực tế và chia sẻ trải nghiệm tác giả cho bài viết an-gi-sri-lanka",
    "rel": "an-gi-sri-lanka.astro",
    "stt": 27
  },
  {
    "time": "2026-10-04 14:37",
    "name": "Bát Đạt Lĩnh Ở Đâu? Kinh Nghiệm Tham Quan Vạn Lý Trường Thành Từ Bắc Kinh",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/bat-dat-linh",
    "desc": "loai bo box ghi chu cap nhat du thua o phan ket luan",
    "rel": "bat-dat-linh.astro",
    "stt": 28
  },
  {
    "time": "2026-10-04 17:04",
    "name": "Gia Dục Quan Ở Đâu? Khám Phá Cửa Ngõ Phía Tây Của Vạn Lý Trường Thành",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/gia-duc-quan",
    "desc": "thêm 2 mã nhúng Instagram và tối ưu toàn diện bài viết",
    "rel": "gia-duc-quan.astro",
    "stt": 29
  },
  {
    "time": "2026-10-04 17:41",
    "name": "Thập Sát Hải Shichahai - Nơi Bắc Kinh Xưa Gặp Nhịp Sống Hiện Đại",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/thap-sat-hai",
    "desc": "embed 3 Instagram posts showcasing Yandai Xiejie rooftop, street photography, and lotus season boating",
    "rel": "thap-sat-hai.astro",
    "stt": 30
  },
  {
    "time": "2026-10-05 12:46",
    "name": "Thập Tam Lăng Bắc Kinh - Khám Phá Quần Thể Lăng Mộ Hoàng Gia Nhà Minh",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/thap-tam-lang",
    "desc": "integrate instagram embeds for sacred way and changling",
    "rel": "thap-tam-lang.astro",
    "stt": 31
  },
  {
    "time": "2026-10-05 19:07",
    "name": "18 Điều Cần Biết Trước Khi Khởi Hành Pakistan",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/dieu-can-biet-truoc-khi-khoi-hanh-pakistan",
    "desc": "redirect cherry blossom and roadtrip tours to canonical tour-du-lich-pakistan, update all internal links & cards",
    "rel": "dieu-can-biet-truoc-khi-khoi-hanh-pakistan.astro",
    "stt": 32
  },
  {
    "time": "2026-10-05 22:11",
    "name": "Tour du lịch Pakistan (Mùa Thu)",
    "cat": "Tour (Sản phẩm)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-du-lich-pakistan",
    "desc": "chuyen doi tour Pakistan sang Astro Native, bo sung snippet Himalaya Series va toi uu gallery",
    "rel": "tour/tour-du-lich-pakistan.astro",
    "stt": 33
  },
  {
    "time": "2026-10-06 06:46",
    "name": "PAKISTAN SERIES",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/country/pakistan",
    "desc": "SEO: Redirect tour-lien-tuyen-pakistan-tan-cuong and tour-du-lich-pakistan-iran, update Pakistan country page and navigation",
    "rel": "country/pakistan.astro",
    "stt": 34
  },
  {
    "time": "2026-10-06 07:56",
    "name": "Showroom Thư Viện Ảnh Du Lịch Pakistan Độc Bản – FIT TOUR",
    "cat": "Gallery Showroom (Kho ảnh 16:9)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/gallery-pakistan",
    "desc": "redirect cherry blossom and roadtrip tours to canonical tour-du-lich-pakistan, update all internal links & cards",
    "rel": "gallery-pakistan.astro",
    "stt": 35
  },
  {
    "time": "2026-10-06 08:33",
    "name": "Kinh nghiệm du lịch Pakistan 2026 – Cẩm nang A-Z toàn diện từ HDV thực tế",
    "cat": "Post (Cẩm nang)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/kinh-nghiem-du-lich-pakistan",
    "desc": "resolve 22 fact-check qa items - unesco tentative, connectivity, flight-first itinerary and cultural etiquette",
    "rel": "kinh-nghiem-du-lich-pakistan.astro",
    "stt": 36
  },
  {
    "time": "2026-10-06 20:43",
    "name": "Mebar Tsho Bhutan: Hồ Thiêng Lửa Cháy Ở Bumthang",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/ho-mebar",
    "desc": "301 redirect tour-bhutan-10n9d to tour-bhutan-5n4d, exclude from sitemap, and update internal links",
    "rel": "ho-mebar.astro",
    "stt": 37
  },
  {
    "time": "2026-10-06 22:57",
    "name": "Tu Viện Kurjey Lhakhang Bhutan: Dấu Thân Guru Rinpoche & Nước Thiêng Bumthang",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/tu-vien-kurjey-lhakhang",
    "desc": "301 redirect tour-bhutan-10n9d to tour-bhutan-5n4d, exclude from sitemap, and update internal links",
    "rel": "tu-vien-kurjey-lhakhang.astro",
    "stt": 38
  },
  {
    "time": "2026-10-07 09:53",
    "name": "Thung Lũng Ura Bhutan: Ngôi Làng Giữ Lại Thời Gian Ở Bumthang",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/thung-lung-ura",
    "desc": "301 redirect tour-bhutan-10n9d to tour-bhutan-5n4d, exclude from sitemap, and update internal links",
    "rel": "thung-lung-ura.astro",
    "stt": 39
  },
  {
    "time": "2026-10-07 20:39",
    "name": "Thung Lũng Tang Bhutan: Đi Sâu Vào Di Sản Và Đời Sống Bumthang",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/thung-lung-tang",
    "desc": "chuẩn hóa số hotline CTA bài viết sang 0836 999 909 và cập nhật quy tắc AGENTS/SOP",
    "rel": "thung-lung-tang.astro",
    "stt": 40
  },
  {
    "time": "2026-10-08 18:54",
    "name": "Tour Doanh Nghiệp Trọn Gói - MICE, Hội Nghị, Incentive",
    "cat": "Case Study (Doanh nghiệp & B2B)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour-doanh-nghiep",
    "desc": "sync faqSchema JSON-LD with VTC News citation",
    "rel": "tour-doanh-nghiep/index.astro",
    "stt": 41
  },
  {
    "time": "2026-10-08 18:59",
    "name": "Company Trip cho Doanh Nghiệp",
    "cat": "Page (Doanh nghiệp & Dịch vụ)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/company-trip",
    "desc": "integrate VTC News media links across corporate pages and case studies",
    "rel": "company-trip.astro",
    "stt": 42
  },
  {
    "time": "2026-10-08 18:59",
    "name": "Corporate Retreat cho Doanh Nghiệp",
    "cat": "Page (Doanh nghiệp & Dịch vụ)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/corporate-retreat",
    "desc": "integrate VTC News media links across corporate pages and case studies",
    "rel": "corporate-retreat.astro",
    "stt": 43
  },
  {
    "time": "2026-10-08 18:59",
    "name": "Dia Diem To Chuc Nha Trang",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/dia-diem-to-chuc-nha-trang",
    "desc": "integrate VTC News media links across corporate pages and case studies",
    "rel": "dia-diem-to-chuc-nha-trang.astro",
    "stt": 44
  },
  {
    "time": "2026-10-08 18:59",
    "name": "Địa Điểm Tổ Chức Tour Doanh Nghiệp & Incentive Travel",
    "cat": "Page (Doanh nghiệp & Dịch vụ)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/dia-diem-to-chuc",
    "desc": "integrate VTC News media links across corporate pages and case studies",
    "rel": "dia-diem-to-chuc.astro",
    "stt": 45
  },
  {
    "time": "2026-10-08 18:59",
    "name": "Tổ Chức Sự Kiện Công Ty & MICE Tour",
    "cat": "Page (Doanh nghiệp & Dịch vụ)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/to-chuc-su-kien-cong-ty-cho-doanh-nghiep",
    "desc": "integrate VTC News media links across corporate pages and case studies",
    "rel": "to-chuc-su-kien-cong-ty-cho-doanh-nghiep.astro",
    "stt": 46
  },
  {
    "time": "2026-10-08 18:59",
    "name": "Tour Incentive Travel cho Doanh Nghiệp",
    "cat": "Page (Doanh nghiệp & Dịch vụ)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour-incentive-travel-doanh-nghiep",
    "desc": "integrate VTC News media links across corporate pages and case studies",
    "rel": "tour-incentive-travel-doanh-nghiep.astro",
    "stt": 47
  },
  {
    "time": "2026-10-08 21:02",
    "name": "Tour Đạo Thành Á Đinh của FIT Tour có gì đặc biệt?",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour-dao-thanh-a-dinh-cua-fit-tour-co-gi-dac-biet",
    "desc": "resolve robots.txt indexing issue and fix sqlite 500 error on location filter",
    "rel": "tour-dao-thanh-a-dinh-cua-fit-tour-co-gi-dac-biet.astro",
    "stt": 48
  },
  {
    "time": "2026-10-08 21:02",
    "name": "Danh Sách Tour Du Lịch Cao Cấp",
    "cat": "Page (Doanh nghiệp & Dịch vụ)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tours",
    "desc": "resolve robots.txt indexing issue and fix sqlite 500 error on location filter",
    "rel": "tours/index.astro",
    "stt": 49
  },
  {
    "time": "2026-10-08 21:43",
    "name": "Showroom Thư Viện Ảnh Làng Cổ Cát Tiên Thôn Trung Quốc – FIT TOUR",
    "cat": "Gallery Showroom (Kho ảnh 16:9)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/hinh-anh-cat-tien-thon",
    "desc": "eliminate 404 broken internal links and add 301 rescue redirects",
    "rel": "hinh-anh-cat-tien-thon.astro",
    "stt": 50
  },
  {
    "time": "2026-10-08 21:43",
    "name": "Showroom Thư Viện Ảnh Thổ Lâu Phúc Kiến (UNESCO) – FIT TOUR",
    "cat": "Gallery Showroom (Kho ảnh 16:9)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/hinh-anh-tho-lau-phuc-kien",
    "desc": "eliminate 404 broken internal links and add 301 rescue redirects",
    "rel": "hinh-anh-tho-lau-phuc-kien.astro",
    "stt": 51
  },
  {
    "time": "2026-10-08 21:43",
    "name": "Showroom Thư Viện Ảnh Vụ Nữ Châu Cổ Trấn Giang Tây – FIT TOUR",
    "cat": "Gallery Showroom (Kho ảnh 16:9)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/hinh-anh-vu-nu-chau",
    "desc": "eliminate 404 broken internal links and add 301 rescue redirects",
    "rel": "hinh-anh-vu-nu-chau.astro",
    "stt": 52
  },
  {
    "time": "2026-10-09 10:19",
    "name": "Tour Murmansk Săn Cực Quang Nga 11N10Đ - Khám phá Bắc Cực",
    "cat": "Tour (Sản phẩm)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-murmansk-san-cuc-quang",
    "desc": "remove inaccurate itinerary map from murmansk tour",
    "rel": "tour/tour-murmansk-san-cuc-quang.astro",
    "stt": 53
  },
  {
    "time": "2026-10-09 10:19",
    "name": "ARCTIC",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/country/bac-cuc",
    "desc": "[SEO] Migrate Russian Arctic tour to Murmansk Aurora tour, setup 301 redirect, update cards & Topic Cluster",
    "rel": "country/bac-cuc.astro",
    "stt": 54
  },
  {
    "time": "2026-10-09 10:19",
    "name": "Tour Murmansk Săn Cực Quang Nga 11N10Đ - Khám phá Bắc Cực",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/country/nga",
    "desc": "[SEO] Migrate Russian Arctic tour to Murmansk Aurora tour, setup 301 redirect, update cards & Topic Cluster",
    "rel": "country/nga.astro",
    "stt": 55
  },
  {
    "time": "2026-10-09 10:56",
    "name": "Tu viện Wangditse Lhakhang, Bhutan: cung đi bộ nhìn xuống Thimphu",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/tu-vien-wangditse-lhakhang",
    "desc": "update correct Huynh Hieu Travel avatar and author snippet",
    "rel": "tu-vien-wangditse-lhakhang.astro",
    "stt": 56
  },
  {
    "time": "2026-10-09 11:06",
    "name": "Vì Sao Bumthang Được Gọi Là “Cái Nôi Tâm Linh” Của Bhutan?",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/vi-sao-bumthang-la-cai-noi-tam-linh-bhutan",
    "desc": "301 redirect tour-bhutan-10n9d to tour-bhutan-5n4d, exclude from sitemap, and update internal links",
    "rel": "vi-sao-bumthang-la-cai-noi-tam-linh-bhutan.astro",
    "stt": 57
  },
  {
    "time": "2026-10-09 19:54",
    "name": "Liên Hệ FIT TOUR – Trụ Sở & Hotline Tư Vấn Tour 24/7",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/lien-he",
    "desc": "đồng bộ số giấy phép lữ hành quốc tế 79-1318/2022/CDLQGVN-GP LHQT trên toàn hệ thống",
    "rel": "lien-he.astro",
    "stt": 58
  },
  {
    "time": "2026-10-09 19:54",
    "name": "Tài Khoản Thanh Toán & Hướng Dẫn Chuyển Khoản",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tai-khoan-thanh-toan",
    "desc": "đồng bộ số giấy phép lữ hành quốc tế 79-1318/2022/CDLQGVN-GP LHQT trên toàn hệ thống",
    "rel": "tai-khoan-thanh-toan.astro",
    "stt": 59
  },
  {
    "time": "2026-10-09 19:54",
    "name": "Tour Giang Nam 5 ngày - Khách sạn 4 sao, NO SHOPPING",
    "cat": "Tour (Sản phẩm)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-trung-quoc-giang-nam",
    "desc": "đồng bộ số giấy phép lữ hành quốc tế 79-1318/2022/CDLQGVN-GP LHQT trên toàn hệ thống",
    "rel": "tour/tour-trung-quoc-giang-nam.astro",
    "stt": 60
  },
  {
    "time": "2026-10-09 21:44",
    "name": "Pháo đài Trongsa Dzong, Bhutan: nơi địa lý trở thành quyền lực",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/phao-dai-trongsa-dzong",
    "desc": "hoan thien bai viet phao dai Trongsa Dzong va tich hop 15 hinh anh",
    "rel": "phao-dai-trongsa-dzong.astro",
    "stt": 61
  },
  {
    "time": "2026-10-15 04:42",
    "name": "Tu viện Tiger",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/tu-vien-tigers-nest-bhutan",
    "desc": "hoan thien bai viet Tu vien Tigers Nest Bhutan chuan Editorial SOP va Internal Link",
    "rel": "tu-vien-tigers-nest-bhutan.astro",
    "stt": 62
  },
  {
    "time": "2026-10-15 15:35",
    "name": "Tashichho Dzong (Thimphu Dzong) – Pháo đài vinh quang Bhutan",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/tashichho-dzong",
    "desc": "301 redirect tour-bhutan-10n9d to tour-bhutan-5n4d, exclude from sitemap, and update internal links",
    "rel": "tashichho-dzong.astro",
    "stt": 63
  },
  {
    "time": "2026-10-18 16:44",
    "name": "Pháo đài Punakha Dzong, Bhutan: Cung điện Đại Lạc giữa hai dòng sông",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/punakha-dzong",
    "desc": "deploy bài viết pháo đài Punakha Dzong chuẩn SEO Schema & WCAG AAA",
    "rel": "punakha-dzong.astro",
    "stt": 64
  },
  {
    "time": "2026-10-19 16:45",
    "name": "Checklist Chuẩn Bị Du Lịch Sri Lanka: 17 Điều Du Khách FIT TOUR Cần Biết",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/checklist-du-lich-sri-lanka",
    "desc": "cap nhat sticky CTA bar, toi uu human writing bai khao sat, bo sung Tam Giac Co Do & phat hanh PDF 8 trang",
    "rel": "checklist-du-lich-sri-lanka.astro",
    "stt": 65
  },
  {
    "time": "2026-10-19 18:48",
    "name": "Bãi Biển Negombo, Sri Lanka: Hướng Dẫn Du Lịch & Trải Nghiệm Thực Tế",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/bai-bien-negombo",
    "desc": "hoàn thiện mạng lưới internal link silo 32 bài viết Sri Lanka, sửa link gãy và chuẩn hóa deduplication",
    "rel": "bai-bien-negombo.astro",
    "stt": 66
  },
  {
    "time": "2026-10-19 20:17",
    "name": "Khách Hàng Quay Lại Tây Tạng & Kailash 3 Năm Liên Tiếp",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/khach-hang-quay-lai-tay-tang-kailash-3-nam",
    "desc": "bổ sung adminEditUrl cho 4 bài viết blog",
    "rel": "khach-hang-quay-lai-tay-tang-kailash-3-nam.astro",
    "stt": 67
  },
  {
    "time": "2026-10-19 20:17",
    "name": "Kinh Nghiệm Du Lịch Thanh Hải: Đi Đâu, Mùa Nào Đẹp & Cách Đi Thực Tế",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/kinh-nghiem-du-lich-thanh-hai",
    "desc": "bổ sung adminEditUrl cho 4 bài viết blog",
    "rel": "kinh-nghiem-du-lich-thanh-hai.astro",
    "stt": 68
  },
  {
    "time": "2026-10-19 20:17",
    "name": "Why Travel China Fittour",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/why-travel-china-fittour",
    "desc": "bổ sung adminEditUrl cho 4 bài viết blog",
    "rel": "why-travel-china-fittour.astro",
    "stt": 69
  },
  {
    "time": "2026-10-19 22:30",
    "name": "Jeep Safari Sri Lanka - Chọn Yala, Udawalawe, Minneriya Hay Wilpattu?",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/jeep-safari-sri-lanka",
    "desc": "hoàn thiện mạng lưới internal link silo 32 bài viết Sri Lanka, sửa link gãy và chuẩn hóa deduplication",
    "rel": "jeep-safari-sri-lanka.astro",
    "stt": 70
  },
  {
    "time": "2026-10-20 14:43",
    "name": "Hồ Kandy Sri Lanka: “Biển Sữa” Kiri Muhuda Giữa Cố Đô",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/ho-kandy",
    "desc": "hoàn thiện mạng lưới internal link silo 32 bài viết Sri Lanka, sửa link gãy và chuẩn hóa deduplication",
    "rel": "ho-kandy.astro",
    "stt": 71
  },
  {
    "time": "2026-10-20 16:21",
    "name": "Chùa Xá Lợi Răng Phật Kandy: Thánh Tích & Vương Quyền Sri Dalada Maligawa",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/chua-xa-loi-rang-phat",
    "desc": "hoàn thiện mạng lưới internal link silo 32 bài viết Sri Lanka, sửa link gãy và chuẩn hóa deduplication",
    "rel": "chua-xa-loi-rang-phat.astro",
    "stt": 72
  },
  {
    "time": "2026-10-21 10:05",
    "name": "Trà Ceylon Sri Lanka - Từ Đồi Chè Đến Nhà Máy Và Văn Hóa Uống Trà",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/tra-ceylon-sri-lanka",
    "desc": "hoàn thiện mạng lưới internal link silo 32 bài viết Sri Lanka, sửa link gãy và chuẩn hóa deduplication",
    "rel": "tra-ceylon-sri-lanka.astro",
    "stt": 73
  },
  {
    "time": "2026-10-21 12:49",
    "name": "Trái Cây Sri Lanka: Những Loại Quả Nên Thử Khi Du Lịch",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/trai-cay-sri-lanka",
    "desc": "bổ sung ảnh thực địa sạp trái cây ven đường vào bài viết trai-cay-sri-lanka",
    "rel": "trai-cay-sri-lanka.astro",
    "stt": 74
  },
  {
    "time": "2026-10-21 16:57",
    "name": "Tàu Hỏa Sri Lanka: Kandy – Ella, Vé, Ghế Ngồi & Kinh Nghiệm",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/tau-hoa-sri-lanka",
    "desc": "docs & feat: cập nhật GLOSSARY, ADR 0004 phân tách intent 2 bài tàu hỏa và chuẩn hóa thời lượng tour 8N8Đ",
    "rel": "tau-hoa-sri-lanka.astro",
    "stt": 75
  },
  {
    "time": "2026-10-22 13:21",
    "name": "Thác Ravana ở Ella, Sri Lanka - Có gì đặc biệt?",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/thac-ravana",
    "desc": "hoàn thiện mạng lưới internal link silo 32 bài viết Sri Lanka, sửa link gãy và chuẩn hóa deduplication",
    "rel": "thac-ravana.astro",
    "stt": 76
  },
  {
    "time": "2026-10-22 15:25",
    "name": "Câu Cá Cà Kheo Sri Lanka - Nghề Cá Truyền Thống Hay Chỉ Còn Để Chụp Ảnh?",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/cau-ca-ca-kheo-sri-lanka",
    "desc": "hoàn thiện mạng lưới internal link silo 32 bài viết Sri Lanka, sửa link gãy và chuẩn hóa deduplication",
    "rel": "cau-ca-ca-kheo-sri-lanka.astro",
    "stt": 77
  },
  {
    "time": "2026-10-22 18:58",
    "name": "Pháo Đài Galle, Sri Lanka - Thành Cổ UNESCO Bên Bờ Ấn Độ Dương",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/phao-dai-galle",
    "desc": "hoàn thiện mạng lưới internal link silo 32 bài viết Sri Lanka, sửa link gãy và chuẩn hóa deduplication",
    "rel": "phao-dai-galle.astro",
    "stt": 78
  },
  {
    "time": "2026-10-22 20:29",
    "name": "Gallery Hình Ảnh Du Lịch: 28 Tuyển Tập Thực Địa Độc Bản",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/gallery",
    "desc": "[Deploy] Hoàn tất showroom 112 ảnh du lịch Sri Lanka chuẩn hóa Human Writing và tích hợp Gallery hub",
    "rel": "gallery/index.astro",
    "stt": 79
  },
  {
    "time": "2026-10-22 20:29",
    "name": "Showroom Thư Viện Ảnh Du Lịch Sri Lanka Thực Địa – FIT TOUR",
    "cat": "Gallery Showroom (Kho ảnh 16:9)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/hinh-anh-du-lich-sri-lanka",
    "desc": "Kho ảnh thực tế hơn 50 khoảnh khắc chụp thật tại Sigiriya, Kandy, Ella, Yala và Bãi biển Bentota với khung hình chuẩn 16:9 Masonry Grid.",
    "rel": "hinh-anh-du-lich-sri-lanka.astro",
    "stt": 80
  },
  {
    "time": "2026-10-22 22:45",
    "name": "FIT TOUR Khảo Sát Thực Tế Sri Lanka - Hồ Sơ Thực Địa & Thiết Kế Hành Trình",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/fit-tour-khao-sat-thuc-te-sri-lanka",
    "desc": "hoàn thiện mạng lưới internal link silo 32 bài viết Sri Lanka, sửa link gãy và chuẩn hóa deduplication",
    "rel": "fit-tour-khao-sat-thuc-te-sri-lanka.astro",
    "stt": 81
  },
  {
    "time": "2026-10-23 18:32",
    "name": "Hành trình Con Đường Tơ Lụa x Quỳnh Anh Shyn",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/quynh-anh-shyn-silk-road",
    "desc": "selective remediation for destination hubs, tourcountry, h1, and headmeta",
    "rel": "quynh-anh-shyn-silk-road.astro",
    "stt": 82
  },
  {
    "time": "2026-10-24 10:07",
    "name": "Tour Sikkim - Bhutan 10N9Đ trọn gói - Resort 4 sao",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-sikkim-bhutan",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-sikkim-bhutan.astro",
    "stt": 83
  },
  {
    "time": "2026-10-24 10:27",
    "name": "Tour Đông Phi 13N11Đ - Ethiopia, Kenya và Tanzania",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-dong-phi-13n11d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-dong-phi-13n11d.astro",
    "stt": 84
  },
  {
    "time": "2026-10-24 11:32",
    "name": "Tour Kazakhstan - Kyrgyzstan 8N7Đ - Bay thẳng - Miễn Visa",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-kazakhstan-kyrgyzstan-8n7d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-kazakhstan-kyrgyzstan-8n7d.astro",
    "stt": 85
  },
  {
    "time": "2026-10-24 11:51",
    "name": "BHUTAN SERIES",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/country/bhutan",
    "desc": "301 redirect tour-bhutan-10n9d to tour-bhutan-5n4d, exclude from sitemap, and update internal links",
    "rel": "country/bhutan.astro",
    "stt": 86
  },
  {
    "time": "2026-10-24 11:51",
    "name": "Showroom Thư Viện Ảnh Vương Quốc Hạnh Phúc Bhutan – FIT TOUR",
    "cat": "Gallery Showroom (Kho ảnh 16:9)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/gallery-bhutan",
    "desc": "301 redirect tour-bhutan-10n9d to tour-bhutan-5n4d, exclude from sitemap, and update internal links",
    "rel": "gallery-bhutan.astro",
    "stt": 87
  },
  {
    "time": "2026-10-24 15:26",
    "name": "Tour Bali 5N4Đ trọn gói - Hành trình 5 sao hấp dẫn",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-bali-5n4d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-bali-5n4d.astro",
    "stt": 88
  },
  {
    "time": "2026-10-24 18:01",
    "name": "Chau Phi",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/country/chau-phi",
    "desc": "301 redirect tour-namibia-nam-phi-14n13d to tour-du-lich-nam-phi-namibia-13n12d",
    "rel": "country/chau-phi.astro",
    "stt": 89
  },
  {
    "time": "2026-10-24 18:18",
    "name": "Tour Nam Phi 9N8Đ trọn gói - KS 4-5 sao, lịch trình hấp dẫn",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-nam-phi-9n8d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-nam-phi-9n8d.astro",
    "stt": 90
  },
  {
    "time": "2026-10-24 19:59",
    "name": "Tour Liên Tuyến Trung Đông Ả Rập - Qatar 11N8Đ - KS 4-5 sao",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-lien-tuyen-trung-dong-a-rap-qatar",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-lien-tuyen-trung-dong-a-rap-qatar.astro",
    "stt": 91
  },
  {
    "time": "2026-10-24 20:38",
    "name": "Motor Adventures Ấn Độ - Bhutan Tour 11N10Đ - Tour KS 4 sao",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/motor-adventures-an-do-bhutan",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/motor-adventures-an-do-bhutan.astro",
    "stt": 92
  },
  {
    "time": "2026-10-25 04:48",
    "name": "Tour Bờ Tây Mỹ 11N8Đ trọn gói - KS 4 sao, bay 5 sao",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-bo-tay-my",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-bo-tay-my.astro",
    "stt": 93
  },
  {
    "time": "2026-10-25 05:58",
    "name": "Tour Motor Caravan Trung Hoa 15N14Đ - Hành trình 4000+ km",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-motor-caravan-trung-hoa",
    "desc": "Migrate tour-motor-caravan-trung-hoa sang Astro SOP template",
    "rel": "tour/tour-motor-caravan-trung-hoa.astro",
    "stt": 94
  },
  {
    "time": "2026-10-25 09:00",
    "name": "Tour Motor Adventure Morocco 13 ngày - Núi, sa mạc và ốc đảo",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-motor-adventure-morocco",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-motor-adventure-morocco.astro",
    "stt": 95
  },
  {
    "time": "2026-10-25 09:17",
    "name": "Team Building Quảng Bình 4 ngày 3 đêm",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/team-building-quang-binh",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/team-building-quang-binh.astro",
    "stt": 96
  },
  {
    "time": "2026-10-25 09:58",
    "name": "Tour lễ hội Tiji ở Nepal - Khám phá vùng đất Upper Mustang",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-le-hoi-tiji",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-le-hoi-tiji.astro",
    "stt": 97
  },
  {
    "time": "2026-10-25 10:09",
    "name": "Tour Trekking Annapurna Base Camp 4130m Nepal từ Việt Nam",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/trekking-annapurna-base-camp",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/trekking-annapurna-base-camp.astro",
    "stt": 98
  },
  {
    "time": "2026-10-25 11:06",
    "name": "Tour du lịch Bờ Đông nước Mỹ mùa Giáng Sinh 10 ngày 9 đêm",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/roadtrip-bo-dong-my",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/roadtrip-bo-dong-my.astro",
    "stt": 99
  },
  {
    "time": "2026-10-25 11:53",
    "name": "Tour Hà Giang 4 Ngày 3 Đêm - Cao nguyên đá nở hoa",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-ha-giang-4-ngay",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-ha-giang-4-ngay.astro",
    "stt": 100
  },
  {
    "time": "2026-10-25 20:13",
    "name": "NEPAL SERIES",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/country/nepal",
    "desc": "SEO: Retire tour-nepal, remove static page, redirect to country/nepal and update internal links",
    "rel": "country/nepal.astro",
    "stt": 101
  },
  {
    "time": "2026-10-25 20:25",
    "name": "Tour du lịch Maldives cao cấp - Thuỷ Phi Cơ và Resort 5 sao",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-du-lich-maldives-cao-cap",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-du-lich-maldives-cao-cap.astro",
    "stt": 102
  },
  {
    "time": "2026-10-25 20:40",
    "name": "53+ Quốc Gia, Vùng Lãnh Thổ Và Khu Vực FIT Tour Đã Đi Qua",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/diem-den-fit-tour",
    "desc": "SEO: Redirect tour-du-lich-ai-cap-jordan, tour-trung-dong-15n, tour-du-lich-israel-jordan-ai-cap-13n12d",
    "rel": "diem-den-fit-tour.astro",
    "stt": 103
  },
  {
    "time": "2026-10-25 20:40",
    "name": "Tour du lịch Dubai 5 ngày 4 đêm - Dịch vụ 5 sao toàn chặng",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-du-lich-dubai",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-du-lich-dubai.astro",
    "stt": 104
  },
  {
    "time": "2026-10-25 21:13",
    "name": "Tour Quảng Bình 4 Ngày 3 Đêm - Camping Trạ Ang",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-quang-binh-4-ngay-3-dem",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-quang-binh-4-ngay-3-dem.astro",
    "stt": 105
  },
  {
    "time": "2026-10-25 22:01",
    "name": "Tour Motor Trip Ladakh 8N7Đ trọn gói - Royal Enfiled 450cc",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/motor-trip-ladakh",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/motor-trip-ladakh.astro",
    "stt": 106
  },
  {
    "time": "2026-10-25 22:39",
    "name": "Showroom Thư Viện Ảnh Trekking Trại Căn Cứ Everest Base Camp – FIT TOUR",
    "cat": "Gallery Showroom (Kho ảnh 16:9)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/gallery-everest-base-camp",
    "desc": "SEO: Retire tour-nepal, remove static page, redirect to country/nepal and update internal links",
    "rel": "gallery-everest-base-camp.astro",
    "stt": 107
  },
  {
    "time": "2026-10-25 22:39",
    "name": "LADAKH SERIES",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/country/ladakh",
    "desc": "update all static archives and blog hubs to canonical tour urls",
    "rel": "country/ladakh.astro",
    "stt": 108
  },
  {
    "time": "2026-10-25 22:39",
    "name": "Chạy motor giữa thung lũng núi đá Ladakh",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/cung-duong-motor-ladakh-pangong-hanle-umlingla",
    "desc": "update all static archives and blog hubs to canonical tour urls",
    "rel": "cung-duong-motor-ladakh-pangong-hanle-umlingla.astro",
    "stt": 109
  },
  {
    "time": "2026-10-25 22:39",
    "name": "Họp phổ biến an toàn trước giờ chạy",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/dang-sau-14-riders-chinh-phuc-umlingla",
    "desc": "update all static archives and blog hubs to canonical tour urls",
    "rel": "dang-sau-14-riders-chinh-phuc-umlingla.astro",
    "stt": 110
  },
  {
    "time": "2026-10-25 22:39",
    "name": "Check-in ngã ba sông thiêng Sangam",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/fit-tour-to-chuc-motor-adventure-cho-honda-vietnam",
    "desc": "update all static archives and blog hubs to canonical tour urls",
    "rel": "fit-tour-to-chuc-motor-adventure-cho-honda-vietnam.astro",
    "stt": 111
  },
  {
    "time": "2026-10-25 22:39",
    "name": "Đoàn Motor Trip Ladakh FIT TOUR Khởi Hành",
    "cat": "Gallery Showroom (Kho ảnh 16:9)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/gallery-motor-adventure-ladakh",
    "desc": "update all static archives and blog hubs to canonical tour urls",
    "rel": "gallery-motor-adventure-ladakh.astro",
    "stt": 112
  },
  {
    "time": "2026-10-25 22:39",
    "name": "14 Riders Nhận Chứng Nhận Kỷ Lục Guinness Tại Umling La",
    "cat": "Gallery Showroom (Kho ảnh 16:9)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/hinh-anh-doan-honda-vietnam-tai-himalaya-ladakh",
    "desc": "update all static archives and blog hubs to canonical tour urls",
    "rel": "hinh-anh-doan-honda-vietnam-tai-himalaya-ladakh.astro",
    "stt": 113
  },
  {
    "time": "2026-10-25 22:39",
    "name": "Chạy motor giữa thung lũng đá Ladakh",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/honda-vietnam-and-friends-o-himalaya",
    "desc": "update all static archives and blog hubs to canonical tour urls",
    "rel": "honda-vietnam-and-friends-o-himalaya.astro",
    "stt": 114
  },
  {
    "time": "2026-10-25 22:39",
    "name": "Cung đường dài giữa đại ngàn thung lũng đá",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/motor-adventure-la-gi",
    "desc": "update all static archives and blog hubs to canonical tour urls",
    "rel": "motor-adventure-la-gi.astro",
    "stt": 115
  },
  {
    "time": "2026-10-25 22:39",
    "name": "Motor Trip",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/motor-trip",
    "desc": "update all static archives and blog hubs to canonical tour urls",
    "rel": "motor-trip.astro",
    "stt": 116
  },
  {
    "time": "2026-10-25 22:39",
    "name": "Phổ biến lộ trình và thứ tự di chuyển",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/riding-formation",
    "desc": "update all static archives and blog hubs to canonical tour urls",
    "rel": "riding-formation.astro",
    "stt": 117
  },
  {
    "time": "2026-10-25 22:39",
    "name": "Đoàn xe tập kết chuẩn bị xuất phát",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/road-captain",
    "desc": "update all static archives and blog hubs to canonical tour urls",
    "rel": "road-captain.astro",
    "stt": 118
  },
  {
    "time": "2026-10-25 22:39",
    "name": "Đoàn motor tập kết giữa thung lũng đá",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/vi-sao-ladakh-la-diem-den-dac-biet-voi-motor-adventure",
    "desc": "update all static archives and blog hubs to canonical tour urls",
    "rel": "vi-sao-ladakh-la-diem-den-dac-biet-voi-motor-adventure.astro",
    "stt": 119
  },
  {
    "time": "2026-10-26 06:51",
    "name": "Tour du lịch Iran 10 ngày 9 đêm - Khám phá di sản Ba Tư",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-du-lich-iran",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-du-lich-iran.astro",
    "stt": 120
  },
  {
    "time": "2026-10-26 07:12",
    "name": "Tour Bắc Hà - Y Tý - Sa Pa",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-bac-ha-y-ty-sapa",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-bac-ha-y-ty-sapa.astro",
    "stt": 121
  },
  {
    "time": "2026-10-26 07:31",
    "name": "Tour Mù Căng Chải 4 Ngày 3 Đêm - Khám Phá Sapa Mùa Lúa Chín",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-mu-cang-chay-4-ngay-3-dem",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-mu-cang-chay-4-ngay-3-dem.astro",
    "stt": 122
  },
  {
    "time": "2026-10-26 07:44",
    "name": "Tour Hà Giang - Khám Phá Vòng Cung Đông Bắc",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-ha-giang",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-ha-giang.astro",
    "stt": 123
  },
  {
    "time": "2026-10-26 07:56",
    "name": "Tour Điện Biên Phủ 3 Ngày 2 Đêm - Đón Xuân Tây Bắc",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-dien-bien-3n2d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-dien-bien-3n2d.astro",
    "stt": 124
  },
  {
    "time": "2026-10-26 08:22",
    "name": "Tour Hạ Long 3 Ngày 2 Đêm - Du thuyền Lan Hạ - Legacy Yên Tử",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-ha-long-3n2d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-ha-long-3n2d.astro",
    "stt": 125
  },
  {
    "time": "2026-10-26 08:37",
    "name": "Tour Vòng Cung Đông Bắc 7 ngày 6 đêm - Năm 2022",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-vong-cung-dong-bac",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-vong-cung-dong-bac.astro",
    "stt": 126
  },
  {
    "time": "2026-10-26 08:49",
    "name": "Tour Tây Bắc 5 Ngày 4 Đêm - Xuân Về Trên Bản Làng",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-tay-bac-5n4d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-tay-bac-5n4d.astro",
    "stt": 127
  },
  {
    "time": "2026-10-26 08:58",
    "name": "Tour Hà Nội - Hạ Long - Ninh Bình - Sapa 6 ngày 5 đêm",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-ha-noi-ha-long-ninh-binh-sapa",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-ha-noi-ha-long-ninh-binh-sapa.astro",
    "stt": 128
  },
  {
    "time": "2026-10-26 09:36",
    "name": "Tour Bắc Cương 10N9Đ trọn gói - KS 4 sao",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-bac-cuong",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-bac-cuong.astro",
    "stt": 129
  },
  {
    "time": "2026-10-26 09:46",
    "name": "Tour Lệ Giang 6N5Đ trọn gói - Khách sạn 4 sao - Bay thẳng",
    "cat": "Tour (Sản phẩm)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-le-giang-6n5d",
    "desc": "toi uu khoang cach danh sach trai nghiem hap dan",
    "rel": "tour/tour-le-giang-6n5d.astro",
    "stt": 130
  },
  {
    "time": "2026-10-26 10:00",
    "name": "Tour Ethiopia - Kenya trọn gói 11N10Đ - Safari Lodge",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-ethiopia-kenya",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-ethiopia-kenya.astro",
    "stt": 131
  },
  {
    "time": "2026-10-26 10:41",
    "name": "Tour Motor Châu Phi 18 ngày - Nam Phi và Namibia",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-motor-chau-phi",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-motor-chau-phi.astro",
    "stt": 132
  },
  {
    "time": "2026-10-26 11:12",
    "name": "Tour Thổ Nhĩ Kỳ 10N9Đ trọn gói - Khách sạn 4-5 sao",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-tho-nhi-ky-9n",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-tho-nhi-ky-9n.astro",
    "stt": 133
  },
  {
    "time": "2026-10-26 13:01",
    "name": "Motor Tour châu Âu 16 ngày dãy Alps: Đức, Áo, Ý, Thụy Sĩ, Pháp",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/motor-tour-chau-au",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/motor-tour-chau-au.astro",
    "stt": 134
  },
  {
    "time": "2026-10-26 13:26",
    "name": "Tour Trekking Everest Base Camp 15N15Đ - Trọn gói hỗ trợ A-Z",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/trekking-everest-base-camp",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/trekking-everest-base-camp.astro",
    "stt": 135
  },
  {
    "time": "2026-10-26 13:59",
    "name": "Tour khám phá Nepal - Bhutan 9 ngày 8 đêm",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-nepal-bhutan",
    "desc": "migrate tour-nepal-bhutan to Astro Native SSR adhering to SOP benchmark",
    "rel": "tour/tour-nepal-bhutan.astro",
    "stt": 136
  },
  {
    "time": "2026-10-26 14:36",
    "name": "TÂY TẠNG SERIES",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/country/tay-tang",
    "desc": "301 redirect tour-tay-tang-10n9d to canonical tour-tay-tang",
    "rel": "country/tay-tang.astro",
    "stt": 137
  },
  {
    "time": "2026-10-26 14:36",
    "name": "Showroom Thư Viện Ảnh Vùng Đất Thiêng Tây Tạng – FIT TOUR",
    "cat": "Gallery Showroom (Kho ảnh 16:9)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/gallery-tay-tang",
    "desc": "301 redirect tour-tay-tang-10n9d to canonical tour-tay-tang",
    "rel": "gallery-tay-tang.astro",
    "stt": 138
  },
  {
    "time": "2026-10-26 14:36",
    "name": "Showroom Thư Viện Ảnh Vùng Đất Shangri-La Đạo Thành Á Đinh – FIT TOUR",
    "cat": "Gallery Showroom (Kho ảnh 16:9)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/hinh-anh-dao-thanh-a-dinh",
    "desc": "301 redirect tour-tay-tang-10n9d to canonical tour-tay-tang",
    "rel": "hinh-anh-dao-thanh-a-dinh.astro",
    "stt": 139
  },
  {
    "time": "2026-10-26 15:55",
    "name": "Showroom Thư Viện Ảnh Huyền Bí Ai Cập Cổ Đại – FIT TOUR",
    "cat": "Gallery Showroom (Kho ảnh 16:9)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/gallery-ai-cap",
    "desc": "SEO: Redirect tour-du-lich-ai-cap-jordan, tour-trung-dong-15n, tour-du-lich-israel-jordan-ai-cap-13n12d",
    "rel": "gallery-ai-cap.astro",
    "stt": 140
  },
  {
    "time": "2026-10-26 15:55",
    "name": "Showroom Thư Viện Ảnh Đại Kim Tự Tháp Giza Ai Cập – FIT TOUR",
    "cat": "Gallery Showroom (Kho ảnh 16:9)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/hinh-anh-kim-tu-thap",
    "desc": "SEO: Redirect tour-du-lich-ai-cap-jordan, tour-trung-dong-15n, tour-du-lich-israel-jordan-ai-cap-13n12d",
    "rel": "hinh-anh-kim-tu-thap.astro",
    "stt": 141
  },
  {
    "time": "2026-10-26 16:12",
    "name": "Showroom Thư Viện Ảnh Sa Mạc & Di Sản Nam Cương – FIT TOUR",
    "cat": "Gallery Showroom (Kho ảnh 16:9)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/hinh-anh-nam-cuong",
    "desc": "SEO: Retire tour-tan-cuong, redirect to tour-tan-cuong-road-trip and flatten redirect chains",
    "rel": "hinh-anh-nam-cuong.astro",
    "stt": 142
  },
  {
    "time": "2026-10-26 16:22",
    "name": "Xuyên Rừng Tuyết Song Phong Cáp Nhĩ Tân -29°C Cùng Trần Thịnh",
    "cat": "Post (Cẩm nang)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/chinh-phuc-rung-tuyet-song-phong-cap-nhi-tan",
    "desc": "SEO: Retire tour-tan-cuong, redirect to tour-tan-cuong-road-trip and flatten redirect chains",
    "rel": "chinh-phuc-rung-tuyet-song-phong-cap-nhi-tan.astro",
    "stt": 143
  },
  {
    "time": "2026-10-26 17:26",
    "name": "Tour Tây Tạng 8 ngày 7 đêm: Lịch trình HẤP DẪN",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-tay-tang",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-tay-tang.astro",
    "stt": 144
  },
  {
    "time": "2026-10-26 19:52",
    "name": "Tour du lịch Ladakh 8N7Đ - Roadtrip từ TPHCM - KS 4 sao",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-ladakh-roadtrip",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-ladakh-roadtrip.astro",
    "stt": 145
  },
  {
    "time": "2026-10-26 21:15",
    "name": "Tour Tân Cương 9N8Đ trọn gói - Road Trip - No Shopping",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-tan-cuong-road-trip",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-tan-cuong-road-trip.astro",
    "stt": 146
  },
  {
    "time": "2026-10-26 21:28",
    "name": "Tour Trung Quốc 7 ngày 7 đêm - Khám phá Trung Nguyên",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-trung-quoc-7n7d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-trung-quoc-7n7d.astro",
    "stt": 147
  },
  {
    "time": "2026-10-26 21:37",
    "name": "Tour du lịch Quý Châu 6 ngày 5 đêm - KS 4 sao - No Shopping",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-quy-chau-6n5d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-quy-chau-6n5d.astro",
    "stt": 148
  },
  {
    "time": "2026-10-26 21:45",
    "name": "Tour Con Đường Tơ Lụa 22 ngày - Hành trình 5stan đặc biệt",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-con-duong-to-lua-22n",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-con-duong-to-lua-22n.astro",
    "stt": 149
  },
  {
    "time": "2026-10-27 05:36",
    "name": "Tour Malaysia 4N3Đ - Hành trình đảo Borneo - Kota Kinabalu",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-malaysia-4n3d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-malaysia-4n3d.astro",
    "stt": 150
  },
  {
    "time": "2026-10-27 05:51",
    "name": "Tour New Zealand Cung Đường Mùa Thu 11N8Đ - KS 4 sao",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-new-zealand-mua-thu",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-new-zealand-mua-thu.astro",
    "stt": 151
  },
  {
    "time": "2026-10-27 06:03",
    "name": "Tour Bắc Âu 11 ngày trọn gói - 4 nước - Trải nghiệm Luxury",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-bac-au-11n",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-bac-au-11n.astro",
    "stt": 152
  },
  {
    "time": "2026-10-27 06:16",
    "name": "Tour Nga 10 ngày Trọn gói - Khách sạn 4 sao, trải nghiệm",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-nga-10n",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-nga-10n.astro",
    "stt": 153
  },
  {
    "time": "2026-10-27 06:38",
    "name": "Tour Đức - Hà Lan - Bỉ - Pháp - Thuỵ Sĩ - Ý 9 ngày 7 đêm",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-duc-ha-lan-bi-phap-thuy-si-y",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-duc-ha-lan-bi-phap-thuy-si-y.astro",
    "stt": 154
  },
  {
    "time": "2026-10-27 06:45",
    "name": "Tour Pháp - Thuỵ Sĩ - Ý - Áo - Đức 10 ngày 8 đêm trọn gói",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-phap-thuy-si-y-ao-duc-10-ngay-8-dem",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-phap-thuy-si-y-ao-duc-10-ngay-8-dem.astro",
    "stt": 155
  },
  {
    "time": "2026-10-27 06:58",
    "name": "Tour Canada 12N11Đ - Đi như người bản địa - bờ Đông và bờ Tây",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-canada-12n11d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-canada-12n11d.astro",
    "stt": 156
  },
  {
    "time": "2026-10-27 07:19",
    "name": "Tour Nam Mỹ 22N21Đ - Peru, Bolivia, Chile và đảo Phục Sinh",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-nam-my-22n21d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-nam-my-22n21d.astro",
    "stt": 157
  },
  {
    "time": "2026-10-27 07:31",
    "name": "Tour Kashmir - Zanskar 11 ngày 10 đêm trọn gói",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-kashmir-zanskar",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-kashmir-zanskar.astro",
    "stt": 158
  },
  {
    "time": "2026-10-27 07:39",
    "name": "Tour Tứ Xuyên 8N7Đ trọn gói - Hành trình Thiên Phủ Chi Quốc",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-tu-xuyen-8n7d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-tu-xuyen-8n7d.astro",
    "stt": 159
  },
  {
    "time": "2026-10-27 07:52",
    "name": "Tour hành hương Nhật Bản 6N5Đ trọn gói",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-hanh-huong-nhat-ban",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-hanh-huong-nhat-ban.astro",
    "stt": 160
  },
  {
    "time": "2026-10-27 08:02",
    "name": "Tour hành hương Hàn Quốc 7N6Đ - Khách sạn 4 sao",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-hanh-huong-han-quoc-7n6d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-hanh-huong-han-quoc-7n6d.astro",
    "stt": 161
  },
  {
    "time": "2026-10-27 08:10",
    "name": "Tour Nam Cực 19N18Đ trọn gói - Khách sạn 5 sao, tàu phá băng",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-nam-cuc-19n18d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-nam-cuc-19n18d.astro",
    "stt": 162
  },
  {
    "time": "2026-10-27 08:19",
    "name": "Tour Caravan Trung Quốc - Hành trình 7000+ km từ Việt Nam",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-caravan-trung-quoc",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-caravan-trung-quoc.astro",
    "stt": 163
  },
  {
    "time": "2026-10-27 08:46",
    "name": "Tour Giang Tây - Phúc Kiến 6N5Đ trọn gói - KS 4 sao",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-giang-tay-phuc-kien-6n5d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-giang-tay-phuc-kien-6n5d.astro",
    "stt": 164
  },
  {
    "time": "2026-10-27 08:55",
    "name": "Motor Adventures Kyrgyzstan 1480km Tour - Hành trình Trung Á",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/motor-adventures-kyrgyzstan",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/motor-adventures-kyrgyzstan.astro",
    "stt": 165
  },
  {
    "time": "2026-10-27 09:03",
    "name": "Tour Seoul mùa đông 5N4Đ trọn gói - Đón lễ Noel và năm mới",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-seoul-mua-dong-5n4d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-seoul-mua-dong-5n4d.astro",
    "stt": 166
  },
  {
    "time": "2026-10-27 09:11",
    "name": "Tour Tây Á 13N12Đ đến 3 nước Azerbaijan - Georgia - Armenia",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-tay-a-3-nuoc",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-tay-a-3-nuoc.astro",
    "stt": 167
  },
  {
    "time": "2026-10-27 09:20",
    "name": "Tour du lịch Myanmar 5 ngày 4 đêm - Khám phá xứ Phật",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-myanmar-5n4d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-myanmar-5n4d.astro",
    "stt": 168
  },
  {
    "time": "2026-10-27 09:31",
    "name": "Tour du lịch Lào 6 ngày 5 đêm: Bay toàn chặng, 5* Vien Tiane",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-lao-6n5d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-lao-6n5d.astro",
    "stt": 169
  },
  {
    "time": "2026-10-27 10:09",
    "name": "Tour du lịch Ladakh, Ấn Độ khởi hành từ Hà Nội (Road Trip)",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-ladakh-khoi-hanh-ha-noi",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-ladakh-khoi-hanh-ha-noi.astro",
    "stt": 170
  },
  {
    "time": "2026-10-27 10:18",
    "name": "Tour du lịch Georgia: Khám phá Caucasus và lịch sử Xô Viết",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-georgia",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-georgia.astro",
    "stt": 171
  },
  {
    "time": "2026-10-27 10:32",
    "name": "Tour du lịch Azerbaijan & Gruzia: Con đường tơ lụa Caucasus",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-du-lich-azerbaijan-gruzia",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-du-lich-azerbaijan-gruzia.astro",
    "stt": 172
  },
  {
    "time": "2026-10-27 10:40",
    "name": "Tour Vân Nam Trung Quốc trọn gói 8N7Đ - No Shopping",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-van-nam",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-van-nam.astro",
    "stt": 173
  },
  {
    "time": "2026-10-27 10:48",
    "name": "Tour du lịch Maldives trọn gói - Resort 4 sao hấp dẫn",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-du-lich-maldives-tron-goi",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-du-lich-maldives-tron-goi.astro",
    "stt": 174
  },
  {
    "time": "2026-10-27 10:57",
    "name": "Tour Đảo Lý Sơn 4 Ngày 3 Đêm - Khám phá hòn đảo núi lửa",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-dao-ly-son-4n3d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-dao-ly-son-4n3d.astro",
    "stt": 175
  },
  {
    "time": "2026-10-27 11:06",
    "name": "Tour du lịch Trung Quốc 7 ngày 6 đêm từ TPHCM",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-trung-quoc-7n6d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-trung-quoc-7n6d.astro",
    "stt": 176
  },
  {
    "time": "2026-10-27 11:15",
    "name": "Tour Cuba và Canada 11 ngày 10 đêm - Khách sạn 4 sao",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-cuba-canada",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-cuba-canada.astro",
    "stt": 177
  },
  {
    "time": "2026-10-27 11:35",
    "name": "Tour Đông Âu 12 ngày trọn gói 4 sao - Hành trình 6 quốc gia",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-dong-au-12n",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-dong-au-12n.astro",
    "stt": 178
  },
  {
    "time": "2026-10-27 11:50",
    "name": "Tour Nam Mỹ 14N13Đ cao cấp đi qua Brazil, Peru, Argentina",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-nam-my-14n13d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-nam-my-14n13d.astro",
    "stt": 179
  },
  {
    "time": "2026-10-27 12:46",
    "name": "Motor Adventures Pakistan Tour 9N8Đ - Hành trình 1405 km",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/motor-adventures-pakistan",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/motor-adventures-pakistan.astro",
    "stt": 180
  },
  {
    "time": "2026-10-27 13:01",
    "name": "Tour Armenia và Bắc Iran 13 ngày trọn gói - Tuyến độc lạ",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-armenia-bac-iran",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-armenia-bac-iran.astro",
    "stt": 181
  },
  {
    "time": "2026-10-27 14:27",
    "name": "Tour Tứ Đại Danh Sơn Trung Quốc 12 ngày Trọn gói",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-tu-dai-danh-son",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-tu-dai-danh-son.astro",
    "stt": 182
  },
  {
    "time": "2026-10-27 14:42",
    "name": "Tour núi lửa Bromo 6N5Đ - Săn bình minh và Trekking",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-bromo-6n5d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-bromo-6n5d.astro",
    "stt": 183
  },
  {
    "time": "2026-10-27 15:03",
    "name": "Tour Greenland – Iceland 12N11Đ – Thiết Kế Riêng Bởi FIT Tour",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-iceland-10n",
    "desc": "migrate tour-iceland-10n sang Astro Native theo chuan SOP",
    "rel": "tour/tour-iceland-10n.astro",
    "stt": 184
  },
  {
    "time": "2026-10-27 15:30",
    "name": "Tour du lịch Tứ Xuyên - Hồ Nam 13 ngày 12 đêm - Trung Quốc",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-tu-xuyen-ho-nam",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-tu-xuyen-ho-nam.astro",
    "stt": 185
  },
  {
    "time": "2026-10-27 15:43",
    "name": "Tour Ladakh mùa lễ hội Hemis",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-ladakh-mua-le-hoi-hemis",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-ladakh-mua-le-hoi-hemis.astro",
    "stt": 186
  },
  {
    "time": "2026-10-27 16:06",
    "name": "Trekking Trại căn cứ Everest cùng huyền thoại Kami Rita",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/trekking-trai-can-cu-everest",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/trekking-trai-can-cu-everest.astro",
    "stt": 187
  },
  {
    "time": "2026-10-27 18:03",
    "name": "Tour Trung Quốc 6 ngày 6 đêm - Khám phá cố đô Trung Hoa",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-trung-quoc-co-do",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-trung-quoc-co-do.astro",
    "stt": 188
  },
  {
    "time": "2026-10-27 18:54",
    "name": "Tour Campuchia 4 Ngày 3 Đêm - Siemreap - Angkor - Cố đô Kulen",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-campuchia-4n3d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-campuchia-4n3d.astro",
    "stt": 189
  },
  {
    "time": "2026-10-27 19:39",
    "name": "Tour du lịch Nam Phi - Namibia 13N12Đ trọn gói - Khách sạn 4 sao",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-du-lich-nam-phi-namibia-13n12d",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-du-lich-nam-phi-namibia-13n12d.astro",
    "stt": 190
  },
  {
    "time": "2026-10-27 21:12",
    "name": "Trang Tìm Kiếm Thông Minh Toàn Website FIT TOUR (Search Engine)",
    "cat": "Page (Doanh nghiệp & Dịch vụ)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/search",
    "desc": "Nâng cấp kiến trúc tìm kiếm Entity-aware (ADR 0004), lọc tức thì theo điểm đến, chuyên mục, tour độc bản và bài viết cẩm nang.",
    "rel": "search.astro",
    "stt": 191
  },
  {
    "time": "2026-10-28 16:29",
    "name": "Tour Chuyến Tàu Thanh Tạng 10N9Đ - Trại căn cứ EBC",
    "cat": "Tour (Sản phẩm)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-thanh-tang-10n9d",
    "desc": "Tich hop TourBookingModal chuan hoa lead D1, thong bao Telegram va ho tro AI Agent",
    "rel": "tour/tour-thanh-tang-10n9d.astro",
    "stt": 192
  },
  {
    "time": "2026-10-28 21:55",
    "name": "Tour Norway – Lapland – Finland | Săn cực quang & Ông Già Noel",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-lapland-na-uy-phan-lan",
    "desc": "Chuyển đổi hoàn toàn sang Astro Native SSR chuẩn SOP Lệ Giang, tích hợp TourItinerary, Schema Product/Breadcrumb, Mobile CTA Dock và tải <0.8s.",
    "rel": "tour/tour-lapland-na-uy-phan-lan.astro",
    "stt": 193
  },
  {
    "time": "2026-10-30 07:45",
    "name": "Case Study Sự Kiện: Tổ Chức Year End Party Cá Nhân Hóa Trên Du Thuyền 140 Khách",
    "cat": "Case Study (Doanh nghiệp & B2B)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/case-study-to-chuc-yep-indoor-ca-nhan-hoa",
    "desc": "Case Study tiệc tất niên độc bản ven sông Sài Gòn, tối ưu typography WCAG AAA, giao diện Astra Studio tinh gọn và hotline tư vấn B2B chuyên nghiệp.",
    "rel": "case-study-to-chuc-yep-indoor-ca-nhan-hoa.astro",
    "stt": 194
  },
  {
    "time": "2026-10-30 18:50",
    "name": "Case Study MICE Doanh Nghiệp: Dược Phẩm Hoàng Vũ Tri Ân Khách Hàng Cao Cấp",
    "cat": "Case Study (Doanh nghiệp & B2B)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/hanh-trinh-doanh-nghiep-duoc-pham-hoang-vu",
    "desc": "Trang Case Study chuẩn hóa thông tin bảo mật, ảnh thực địa 16:9 sắc nét, dải thông số nhanh và liên kết hệ sinh thái du lịch doanh nghiệp FIT TOUR.",
    "rel": "hanh-trinh-doanh-nghiep-duoc-pham-hoang-vu.astro",
    "stt": 195
  },
  {
    "time": "2026-10-31 11:59",
    "name": "Case Study Tour Private: Đoàn Doanh Nghiệp VIP Khám Phá Hokkaido Mùa Thu",
    "cat": "Case Study (Doanh nghiệp & B2B)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/case-study-tour-private-hokkaido-mua-thu",
    "desc": "Case study hành trình riêng tư thiết kế theo yêu cầu (Tailor-made) tại Sapporo - Otaru - Toya, ẩm thực sao Michelin và suối khoáng nóng Onsen cao cấp.",
    "rel": "case-study-tour-private-hokkaido-mua-thu.astro",
    "stt": 196
  },
  {
    "time": "2026-10-31 18:47",
    "name": "Case Study Teambuilding Doanh Nghiệp: Hành Trình Gắn Kết Miền Tây Sông Nước",
    "cat": "Case Study (Doanh nghiệp & B2B)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/case-study-hanh-trinh-doanh-nghiep-mien-tay",
    "desc": "Xuất bản Case Study du lịch gắn kết doanh nghiệp đồng bằng sông Cửu Long, chuẩn Editorial Hokkaido, internal link silo MICE và hotline 0932 076 186.",
    "rel": "case-study-hanh-trinh-doanh-nghiep-mien-tay.astro",
    "stt": 197
  }
];
